import { updateObject } from 'utils/updateObject'
import {
  DROP_LIST,
  SET,
  SET_LOADING,
} from 'modules/Recommendations/CampaignsRecommendations/TypesList/store/types'

const initialState = {
  loading: true,
  loaded: false,
  data: [],
}

const setRecommendations = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: [...state.data].concat(payload.data),
    loading: false,
    loaded: true,
  })

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropList = (state) =>
  updateObject(state, {
    data: [],
    loading: true,
    loaded: false,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return setLoading(state, action)
    case SET:
      return setRecommendations(state, action)
    case DROP_LIST:
      return dropList(state, action)
    default:
      return state
  }
}

export default reducer
